/* eslint-disable react/prop-types */
import React from "react";
import { Card, FormControl, MenuItem, Select } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import Dropdown from "components/CustomDropdown/Dropdown";

export function Section({ title, description, icon, children, action }) {
  return (
    <Card
      sx={{
        backgroundColor: "white",
        borderRadius: "10px",
        p: { xs: 2, sm: 3 },
        mb: 3,
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        border: "1px solid #f5f5f5",
      }}
    >
      <ArgonBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        mb={3}
        flexWrap="wrap"
      >
        <ArgonBox display="flex" alignItems="center" gap={2}>
          <ArgonBox
            sx={{
              background: "linear-gradient(45deg, #ff956f, #F7931E)",
              borderRadius: "10px",
              p: 1,
              display: "flex",
              color: "white",
              "& svg": { fontSize: 20 },
            }}
          >
            {icon}
          </ArgonBox>
          <ArgonBox>
            <ArgonTypography variant="h6" fontWeight="600" color="#2c3e50">
              {title}
            </ArgonTypography>
            <ArgonTypography variant="body2" color="#6c757d">
              {description}
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>
        {action}
      </ArgonBox>
      {children}
    </Card>
  );
}

export function Choice({ label, value, options, onChange, multiple = false, disabled = false }) {
  return (
    <ArgonBox>
      <ArgonTypography variant="body2" fontWeight="600" mb={1}>
        {label}
      </ArgonTypography>
      {!multiple ? (
        <Dropdown
          label=""
          ariaLabel={label}
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          width="100%"
          options={[{ value: "", label: `Select ${label}` }, ...options]}
        />
      ) : (<FormControl fullWidth>
        <Select
          value={value}
          multiple={multiple}
          disabled={disabled}
          displayEmpty
          inputProps={{ "aria-label": label }}
          onChange={(e) => onChange(e.target.value)}
          renderValue={(selected) => {
            const values = multiple ? selected : [selected];
            return values.length && values[0] !== "" ? (
              options
                .filter((o) => values.includes(o.value))
                .map((o) => o.label)
                .join(", ")
            ) : (
              <span style={{ color: "#7b7a7a" }}>Select {label.toLowerCase()}</span>
            );
          }}
          sx={{
            minHeight: "40px",
            padding: "4px 8px",
            borderRadius: "8px",
            border: "1px solid #d2d6da",
            fontSize: "14px",
            fontWeight: 400,
            color: "#495057",
            backgroundColor: "#fff",
            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            "&.Mui-disabled": { backgroundColor: "#e9ecef" },
            "& .MuiSelect-select": { whiteSpace: "normal" },
          }}
        >
          {!multiple && <MenuItem value="">Select {label.toLowerCase()}</MenuItem>}
          {options.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>)}
    </ArgonBox>
  );
}

export function NumberField({ label, inputProps, ...props }) {
  return (
    <ArgonBox>
      <ArgonTypography variant="body2" fontWeight="600" mb={1}>
        {label}
      </ArgonTypography>
      <ArgonInput
        {...props}
        type="number"
        fullWidth
        inputProps={{ ...inputProps, "aria-label": label }}
      />
    </ArgonBox>
  );
}
